<template>
  <div class="home-page">
    <div class="wrap">
      <!-- <header>
        <div class="header-inner">
          <div class="header-inner--left">
            <h1 class="logo">JODI</h1>
          </div>
          <div class="header-inner--right">
            <span>Find your Dream Home</span>
          </div>
        </div>
      </header>-->
      <AppHeader logoLink="/" />
      <main>
        <div class="bg">
          <div class="bg-layer"></div>
          <h2>{{ $t('title') }}</h2>
          <div class="app-search">
            <form @submit="formSubmit">
              <div class="search-tabs">
                <span :class="{ active: activeTab === 'sell' }" @click="activeTab = 'sell'">Buy</span>
                <span :class="{ active: activeTab === 'rent' }" @click="activeTab = 'rent'">Rent</span>
              </div>
              <div class="input-with-btn">
                <span class="input-with-btn--ipt-wrap">
                  <input
                    v-model="searchContent"
                    type="text"
                    class="input-with-btn--ipt"
                    placeholder="Search for City, Neighborhood, Zip, County, School"
                  />
                </span>
                <button class="input-with-btn--btn" type="submit" @click="search">{{ $t('Search') }}</button>
              </div>
            </form>
          </div>
        </div>
        <div class="main-content">
          <div class="section-about">
            <div class="section-about--left">
              <div class="bg-layer"></div>
              <div class="text-with-border">About JODI Group, Inc.</div>
              <div class="section-about--text">
                JODI Group, Inc. supports the principles of the FAIR HOUSING ACT and EQUAL OPPORTUNITY ACT. For
                information on fair housing and free housing counseling, please visit hud.gov.
              </div>
            </div>
            <div class="section-about--right">
              <div class="section-about--right--top">
                <div class="bg-layer"></div>
                <div class="text-with-border">{{ $t('userTrustedChoice') }}</div>
                <div class="section-about--right--text">{{ $t('servedUsers', { num: statistics.userCount }) }}</div>
              </div>
              <div class="section-about--right--bottom">
                <div class="bg-layer"></div>
                <div class="text-with-border">{{ $t('plentyOfHouses') }}</div>
                <div class="section-about--right--text">
                  {{ $t('getHousesNumber', { num: Number(statistics.rentalCount) + Number(statistics.sellCount) }) }}
                </div>
              </div>
            </div>
          </div>
          <div class="section-sell" v-if="sellItems.length">
            <div class="section--title title-1">
              <h3>{{ $t('beingSold') }}</h3>
              <span class="link-more" @click="goList('sell')">{{ $t('moreSelling') }}</span>
            </div>
            <div class="section-sell-list">
              <ItemSell v-for="item in sellItems" :info="item" :key="item.id" :img="item.gallery[0].url" />
            </div>
          </div>
          <div class="section-rent" v-if="rentItems.length">
            <div class="section--title title-2">
              <h3>{{ $t('beingRent') }}</h3>
              <span class="link-more" @click="goList('rent')">{{ $t('moreRenting') }}</span>
            </div>
            <div class="section-rent-list">
              <ItemRent v-for="item in rentItems" :info="item" :key="item.id" :img="item.gallery[0].url" />
            </div>
          </div>
          <AddonBuyerReso class="section-addon" />
          <div class="section-article">
            <div class="article-title">Explore San Francisco Neighborhoods</div>
            <main-article-list @viewDetail="viewArticleDetail" />
            <div class="article-list-btn" @click="viewArticleDetail(false)">EXPLORE SAN FRANCISCO</div>
          </div>
        </div>
      </main>
    </div>
    <AppFooter />
  </div>
</template>
<script>
// @ is an alias to /src
import { setup } from '@/lang'
import ItemSell from '../components/home/item-sell'
import ItemRent from '../components/home/item-rent'
import AppHeader from '../components/AppHeader'
import AppFooter from '../components/AppFooter'
import AddonBuyerReso from '../components/AddonBuyerReso'
import MainArticleList from '../components/MainArticleList'

// import mockData from '../common/mock-data'
export default {
  name: 'home',
  components: { MainArticleList, ItemSell, ItemRent, AppHeader, AppFooter, AddonBuyerReso },
  data() {
    return {
      activeTab: 'sell',
      searchContent: '',
      sellItems: [],
      rentItems: [],
      statistics: {},
    }
  },
  created() {
    this.getStatistics()
    this.getSellList()
    this.getRentList()
  },
  methods: {
    search() {
      window.open(`/${this.activeTab}/listing?q=${this.searchContent}`)
      // this.$router.push({ name: 'rent', query: { q: this.searchContent } })
    },
    goList(type) {
      location.href = `/${type}/listing`
    },
    setLang(lang) {
      setup(lang)
    },
    formSubmit(e) {
      e.preventDefault()
    },
    getStatistics() {
      this.$axios({
        url: '/api/v1/client/estate/statistics',
        method: 'get',
      })
        .then(res => {
          this.statistics = res.count || {}
        })
        .catch(() => {
          console.error('error on GET:statistics')
        })
    },
    getRentList() {
      this.$axios({
        url: '/api/v1/client/estate/rental/getRentalList?recommendationWeight=5&limit=6',
        method: 'get',
      })
        .then(res => {
          this.rentItems = res.docs
        })
        .catch(() => {
          console.error('error on GET:getRentalList')
        })
    },
    getSellList() {
      this.$axios({
        url: '/api/v1/client/estate/sell/getSellList?recommendationWeight=5&limit=5',
        method: 'get',
      })
        .then(res => {
          this.sellItems = res.docs
        })
        .catch(err => {
          console.log(err)
          console.error('error on GET:getRentalList')
        })
    },
    viewArticleDetail(item) {
      let url = '/api/v1/client/estate/content/getContentDetail/explore-sf'
      if (!item) {
        this.$axios({
          url: url,
          method: 'get',
        })
          .then(res => {
            if (res.ok) {
              this.$store.commit('saveArticle', res.doc)
              //location.href = `/article/${res.doc.slug}`
              this.$router.push({ path: `/article/${res.doc.slug}` })
            }
          })
          .catch(() => {
            console.error('error on GET:getContentDetail')
          })
      } else {
        this.$store.commit('saveArticle', item)
        this.$router.push({ path: `/article/${item.slug}` })
      }
    },
  },
}
</script>
<style lang="less" scoped>
@import url('../assets/less/var.less');

.home-page {
  position: relative;
  background-color: #fff;
}

.wrap {
  min-height: 700px;
}

header {
  border-bottom: 1px solid #d8d8d8;
  background-color: #fff;
}

.header-inner {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: @content-width;
  height: @home-header-height;
  padding: 0 31px;
  margin: 0 auto;
  color: rgba(0, 0, 0, 0.5);
  font-size: 16px;

  h1 {
    font-size: 0;
    text-indent: -999em;
  }

  .logo {
    width: 72px;
    height: 50px;
    background: url('../assets/images/logo-color.png') center no-repeat;
    background-size: 100%;
  }
}

.header-inner--left {
  display: flex;
  align-items: center;

  a {
    margin-right: 59px;
  }
}

.header-inner--right {
  a {
    margin-left: 50px;
  }
}

main {
  .bg {
    position: relative;
    height: 403px;
    background: url('../assets/images/home-banner.jpeg') center top no-repeat;
    background-size: 100%;
    text-align: center;
  }

  .bg-layer {
    content: '';
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: rgba(0, 0, 0, 0.3);
  }

  h2 {
    position: relative;
    margin: 0;
    color: #fff;
    padding-top: 114px;
    font-size: 24px;
  }
}

.app-search {
  position: relative;
  width: 657px;
  margin: 102px auto 0;

  .search-tabs {
    position: absolute;
    top: -32px;
    left: 33px;
  }

  .search-tabs > span {
    display: inline-block;
    // margin-right: 1px;
    height: 32px;
    line-height: 32px;
    padding: 0 28px;
    font-size: 16px;
    color: #fff;
    background-color: rgba(0, 0, 0, 0.5);
    border-radius: 4px 4px 0 0;
    cursor: pointer;
  }

  .search-tabs > span.active {
    background-color: #99d20d;
  }
}

.input-with-btn {
  background: #fff;
  border-radius: 6px;
  overflow: hidden;
}

.input-with-btn--ipt-wrap {
  display: inline-block;
  padding: 8px 28px 9px 14px;
  vertical-align: top;
}

.input-with-btn--ipt {
  width: 495px;
  height: 37px;
  line-height: 37px;
  padding: 8px 14px;
  box-sizing: border-box;
  font-size: 14px;
  border: none;
  border-radius: 6px;
  outline: none;
}

.input-with-btn--btn {
  width: 120px;
  height: 54px;
  line-height: 54px;
  text-align: center;
  background: #9ecf40;
  font-size: 16px;
  color: #fff;
  border: none;
  outline: none;
  cursor: pointer;
}

.gray {
  color: #777;
}

.main-content {
  width: 100%;
  margin: 0 auto;
}

.text-with-border {
  position: relative;
  display: block;
  padding-bottom: 14px;
  font-size: 16px;
  color: rgba(0, 0, 0, 0.85);
}

.text-with-border::after {
  position: absolute;
  bottom: 0;
  left: 0;
  display: block;
  content: '';
  width: 52px;
  height: 4px;
  background: #9ecf40;
}

.section-addon {
  margin: 36px auto 0;
  width: 100%;
}

.section-about {
  margin: 22px auto 0;
  width: @main-content-width;
  color: rgba(0, 0, 0, 0.85);

  .bg-layer {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #e9ebed;
    opacity: 0.1;
  }
}

.section-about--left {
  position: relative;
  display: inline-block;
  width: 49.3%;
  height: 260px;
  padding: 49px 19px 0;
  box-sizing: border-box;
  background: url('../assets/images/home-bg.png') right bottom no-repeat;
  background-size: cover;
  border-radius: 4px;
  overflow: hidden;
}

.section-about--text {
  position: relative;
  margin-top: 30px;
  width: 347px;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.85);
  line-height: 1.8;
}

.section-about--right {
  width: 49.3%;
  display: inline-block;
  vertical-align: top;
  margin-left: 1.4%;
}

.section-about--right--top,
.section-about--right--bottom {
  position: relative;
  padding: 26px 22px 0;
  box-sizing: border-box;
  border-radius: 4px;
  overflow: hidden;
}

.section-about--right--top {
  height: 126px;
  background: url('../assets/images/home-bg-2.png') center top no-repeat;
  background-size: cover;
  margin-bottom: 8px;
}

.section-about--right--bottom {
  height: 126px;
  background: url('../assets/images/home-bg-3.png') center top no-repeat;
  background-size: cover;
  margin-bottom: 8px;
}

.section-about--right--text {
  position: relative;
  font-size: 14px;
  color: #3c3c3c;
  margin-top: 22px;
}

.section--title {
  display: flex;
  justify-content: space-between;
  align-items: center;

  .link-more {
    font-size: 14px;
    color: #99d20d;
    cursor: pointer;
  }
}

.section-sell {
  margin: 36px auto 0;
  width: @main-content-width;
}

.section-rent {
  margin: 36px auto 0;
  width: @main-content-width;
}

h3 {
  font-size: 18px;
  color: rgba(0, 0, 0, 0.85);
  margin-bottom: 22px;
}

.section-sell-list,
.section-rent-list {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}

.section-rent-list {
  padding-bottom: 36px;
}

.section-article {
  margin-top: 72px;
  margin-bottom: 97px;
  padding-bottom: 40px;
  background-color: #f9f9f9;
  user-select: none;

  .article-title {
    margin: 0 auto;
    padding-top: 27px;
    width: 50%;
    height: 24px;
    font-size: 18px;
    font-weight: 600;
    color: rgba(51, 51, 51, 1);
    line-height: 24px;
    text-align: center;
  }

  .article-list-btn {
    margin: 33px auto 0;
    width: 263px;
    height: 45px;
    background: rgba(51, 51, 51, 1);
    border: 2px solid rgba(249, 249, 249, 1);
    font-size: 14px;
    font-weight: 600;
    color: rgba(249, 249, 249, 1);
    line-height: 45px;
    text-align: center;
    cursor: pointer;
  }
}

.section-notice {
  background-color: #f9f9f9;
  color: #333;
  padding: 27px 0 35px;
  margin: 0 auto 20px;

  .section-notice-inner {
    width: 896px;
    margin: 0 auto;
  }
}
</style>
